import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(),
        getByOrder: state => orderId => {
            return state.objs.filter(p => p.order === orderId);
        },
    },
    mutations: {
        ...functions.createDefaultMutations()
    },
    actions: {
        ...functions.createDefaultActionsWithStore()
    },
}